import React from 'react';
import { renderIf } from 'constants/general';
import { Spinner } from 'lego-dist';

interface RenderIfProps {
  condition: any;
  loading?: boolean;
  loadingState?: any;
  children: any;
  alternative?: any;
  error?: any;
  errorView?: any;
}

/**
 *
 * @param condition {Bollean} [Confidence to be fulfilled ]
 * @param component <Component/> [Component to be rendered if the condition is true]
 * @param alternativeComponent < Component /> [Alternative component to render if condition is false]
 */
const RenderIf: React.FC<RenderIfProps> = ({
  condition,
  loading = false,
  loadingState = <Spinner loading position="absolute" />,
  children,
  alternative,
  error,
  errorView,
}) => renderIf(condition, loading, loadingState, children, alternative, error, errorView);

export default RenderIf;
